import React, { useState } from 'react'
import { useHistory } from "react-router-dom"

import { TextField, Button, Step, Stepper } from "@mui/material"

import "./Register.scss"

const Register = () => {
    const [enteredData, setEnteredData] = useState({
        email: "",
        password: ""
    })
    const enteringData = (event) => {

        let { name, value } = event.target

        setEnteredData((preValue) => {
            return {
                ...preValue,
                [name]: value
            }
        })
    }
    return (
        <>
            <div className="login_container">
                <div className="heading">
                    ADMIN-LOGIN
                </div>
                <div className="form">
                    <TextField name="email" value={enteredData.email} onChange={enteringData} className="input" label="username" />
                    <TextField name="password" value={enteredData.password} onChange={enteringData} type="password" className="input" label="password" />
                </div>
                <Button className="btn"> LOGIN </Button>
            </div>
        </>
    )
}

export default Register
